// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1J5uJ","signatureBlock":"Footer_signatureBlock__1pNtf","signature":"Footer_signature__xcRK-"};